import { Console } from "console";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import { Menu } from "react-feather";
import { Oval } from "react-loader-spinner";
import { IFuncionarioCartorio, useFuncionarioCartorio } from "../../Hooks/funcionarioCartorio";
import { IImovelFormatado, useImovel } from "../../Hooks/imoveis";
import { IOperacao } from "../../Hooks/operacoes";
import { IPrefeitura, IPrefeituraAssets } from "../../Hooks/usePrefeitura";
import { cpfMask } from "../../Services/cpfMask";
import theme from "../../Styles/theme";
import { logos } from "../../Utils/baseUrlLogos";
import { maskCell } from "../../Utils/maskCell";
import { LigacaoPrefeituraButton } from "../Buttons/LigacaoPrefeituraButton";
import { Editar_Excluir_Operacoes } from "../Editar_Excluir_Operacoes";
import { HelperFuncionariosOperation } from "../HelperFuncionariosOperation";
import { ImovelModalOptions } from "../ImovelModalOptions";
import { useNavigate } from "react-router-dom";

import {
  Container,
  Header,
  Body,
  ButtonAba,
  Table,
  TBody,
  HeaderTable,
  TableContainer,
  HeaderItem,
  TableData,
  TabelaLinha,
  PLoader,
  PrefeiturasDiv,
  ItemPrefeitura,
  LogoPrefeitura,
  TitlePrefeitura,
  ImageHelper,
  DivAbas,
  DivFiltro,
  ButtonFiltro,
} from "./styles";
import { app_base_url, app_full_url } from "../../Utils/baseUrl";
import { IFuncionarioPrefeitura } from "../../Hooks/funcionarioPrefeitura";
import { ICartorios } from "../../Pages/Cartorio_Pages/App_Pages/Cartorios";
import { EditarRelacoesPref_Cart } from "../EditarRelacoesPref_Cart";
import { cnpjMask } from "../../Services/cnpjMask";
import { FiltroImovelModal } from "../FiltroImovelModal";
import { ModalLoader } from "../ModalLoader";
import { useCartorio } from "../../Hooks/cartorio";

export interface IAba {
  title: string;
  execute(): void;
  index: number;
  execute(): void;
}

interface Props {
  abas: IAba[];
  index: number;
  conteudoTabelaFuncionario?: IFuncionarioCartorio[] | IFuncionarioPrefeitura[];
  conteudoTabelaImovel?: IImovelFormatado[];
  conteudoTabelaPrefeituras?: IPrefeitura[];
  conteudoTabelaPrefeiturasAssets?: IPrefeituraAssets[];
  tableHeader: String[];
  loading: boolean;
  imoveis?: boolean;
  operacoes?: IOperacao[];
  conteudoTabelaCartorios?: ICartorios[];
}

export function TablePanel({
  loading,
  abas,
  index,
  conteudoTabelaFuncionario,
  conteudoTabelaImovel,
  tableHeader,
  imoveis = false,
  conteudoTabelaPrefeituras,
  conteudoTabelaPrefeiturasAssets,
  operacoes,
  conteudoTabelaCartorios,
}: Props) {
  const {cartorioIsLogged} = useCartorio();
  const {funcionarioCartorioIsLogged} = useFuncionarioCartorio();
  const [hiddenTableHeader, sethiddenTableHeader] = useState(false);
  const [editar_excluir_operacoes, setEditarExcluirOperacoes] = useState(
    {} as IOperacao
  );
  const [imovelModalOptionsOpen, setImovelModalOptions] = useState(false);
  const [
    cartorio_pref_relacao_focus,
    setCartorio_pref_relacao_focus,
  ] = useState({} as ICartorios);
  const { filtro } = useImovel();
  const [cartorio_relacao_modal, setCartorio_relacao_modal] = useState(false);
  const [openFiltroImovelModal, setOpenFiltroImovelModal] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    console.log(conteudoTabelaPrefeituras);
  }, [conteudoTabelaPrefeituras]);
  //useEffect(() => {}, [abas]);
  function renderTable() {
    if (conteudoTabelaFuncionario) {
      if (conteudoTabelaFuncionario.length > 0) {
        return conteudoTabelaFuncionario.map((item) => {
          return (
            <HelperFuncionariosOperation
              funcionario={item}
              children={
                <>
                  <TableData>{item.ID}</TableData>
                  <TableData>{item.NOME}</TableData>
                  <TableData>{item.EMAIL}</TableData>
                  <TableData>{cpfMask(item.CPF)}</TableData>
                  <TableData>{item.FONE ? maskCell(item.FONE) : "-"}</TableData>
                  <TableData>
                    {item.WHATS ? maskCell(item.WHATS) : "-"}
                  </TableData>
                  {cartorioIsLogged?<></>: <TableData>
                    {item.AVALIAR}
                  </TableData>}
                 

                </>
              }
              handleCheckModalOpen={() => {
                sethiddenTableHeader(!hiddenTableHeader);
              }}
            />
          );
        });
      }
    }

    if (conteudoTabelaImovel) {
      if (conteudoTabelaImovel.length > 0) {
        return conteudoTabelaImovel.map((item) => {
          return (
            <TabelaLinha
              onClick={() => {
                if (item.BAIRRO) {
                  window.open(
                    `${app_full_url}/imovel/${item.ID}`,
                    "_blank"
                  );
                } else {
                  window.open(
                    `${app_full_url}/imovel-rural/${item.ID}`,
                    "_blank"
                  );
                  
                }
              }}
            >
              <TableData>
                {item.NUMERO}/{new Date(item.DATA_CRIACAO).getFullYear()}
              </TableData>
              {item.AVALIADO ? (
                <TableData>
                  {new Date(item.AVALIADO!).toLocaleDateString("pt-br")}
                </TableData>
              ) : (
                ""
              )}

              <TableData>{item.MUNICIPIO  ? (funcionarioCartorioIsLogged||cartorioIsLogged? item.MUNICIPIO:item.CARTORIO_TITULO) : "-"}</TableData>
              <TableData>{item.LOCALIZACAO ? item.LOCALIZACAO : "-"}</TableData>
              <TableData>
                {item.AREA ? item.AREA.toLocaleString("pt-BR") + "m²" : "-"}
              </TableData>
              <TableData>
                {item.TRANSMITENTE ? item.TRANSMITENTE : "-"}
              </TableData>
              <TableData>{item.ADQUIRINTE ? item.ADQUIRINTE : "-"}</TableData>
            </TabelaLinha>
          );
        });
      }
    }

    if (conteudoTabelaPrefeituras && conteudoTabelaPrefeiturasAssets) {
      if (
        conteudoTabelaPrefeituras.length > 0 &&
        conteudoTabelaPrefeiturasAssets.length > 0
      ) {
        return (
          <PrefeiturasDiv>
            {conteudoTabelaPrefeituras.map((item) => {
              return (
                <LigacaoPrefeituraButton
                  item={item}
                  children={
                    <ItemPrefeitura>
                      <ImageHelper>
                        {" "}
                        <LogoPrefeitura
                          src={`${logos}/uploads/${
                            conteudoTabelaPrefeiturasAssets[defineLogo(item.ID)]
                              .logo
                          }`}
                          alt=""
                        />{" "}
                      </ImageHelper>
                      <TitlePrefeitura>{item.NOME}</TitlePrefeitura>
                    </ItemPrefeitura>
                  }
                />
              );
            })}
          </PrefeiturasDiv>
        );
      }
    }

    if (conteudoTabelaCartorios) {
      if (conteudoTabelaCartorios.length > 0) {
        return conteudoTabelaCartorios.map((item) => {
          return (
            <TabelaLinha
              style={{ opacity: item.REJEITADO ? 0.7 : 1 }}
              onClick={() => {
                if (!item.REJEITADO) {
                  setCartorio_pref_relacao_focus(item);
                  setCartorio_relacao_modal(true);
                }
              }}
            >
              <TableData>{item.ID}</TableData>
              <TableData>{item.NOME}</TableData>
              <TableData>
                {item.CPF_CNPJ.trim().length == 11
                  ? cpfMask(item.CPF_CNPJ)
                  : cnpjMask(item.CPF_CNPJ)}
              </TableData>
            </TabelaLinha>
          );
        });
      }
    }

    return "";
  }

  function renderOperacoes() {
    if (operacoes) {
      if (operacoes.length > 0) {
        return operacoes.map((item) => {
          return (
            <TabelaLinha
              onClick={() => {
                setEditarExcluirOperacoes(item);
              }}
            >
              <TableData>{item.ID}</TableData>
              <TableData>{item.DESCRICAO}</TableData>
            </TabelaLinha>
          );
        });
      }
    }
  }

  function defineLogo(id: number): number {
    let index = 0;
    if (conteudoTabelaPrefeiturasAssets) {
      if (conteudoTabelaPrefeiturasAssets.length > 0) {
        index = conteudoTabelaPrefeiturasAssets.findIndex(
          (item) => item.id == id
        );
      }
    }
    return index;
  }

  return (
    <Container>
      <Header>
        <DivAbas>
          {abas.map((item) => {
            return (
              <ButtonAba
                focus={index == item.index}
                onClick={() => item.execute()}
              >
                {item.title}
              </ButtonAba>
            );
          })}
        </DivAbas>
        {conteudoTabelaImovel ? (
          <DivFiltro style={{ opacity: filtro.ativo == true ? 1 : 0.8 }}>
            {/* <ButtonFiltro onClick={() => setOpenFiltroImovelModal(true)}>
              Filtrar <Menu size={"max(1.2vw,12px)"} />
            </ButtonFiltro> */}
          </DivFiltro>
        ) : (
          ""
        )}
      </Header>

      <Body>
        <TableContainer id="#TABELA">
          <Table>
            <thead
              hidden={
                loading ||
                hiddenTableHeader ||
                !!editar_excluir_operacoes.ID ||
                imovelModalOptionsOpen ||
                cartorio_relacao_modal ||
                openFiltroImovelModal
              }
            >
              <HeaderTable>
                {tableHeader.map((item) => {
                  return <HeaderItem>{item}</HeaderItem>;
                })}
              </HeaderTable>
            </thead>
            {renderOperacoes()}

            {renderTable()}
          </Table>
          {imoveis ? (
            <>
              {" "}
              {index == 1 ? (
                <PLoader id="sentinela_pendentes">
                  <Oval
                    color={theme.colors.primary}
                    width={"max(2vw, 20px)"}
                    height={"max(2vw, 20px)"}
                    secondaryColor={theme.colors.secondary}
                    visible={loading}
                  />
                  P
                </PLoader>
              ) : (
                ""
              )}
              {index == 2 ? (
                <PLoader id="sentinela_enviados">
                  <Oval
                    color={theme.colors.primary}
                    width={"max(2vw, 20px)"}
                    height={"max(2vw, 20px)"}
                    secondaryColor={theme.colors.secondary}
                    visible={loading}
                  />
                  E
                </PLoader>
              ) : (
                ""
              )}
              {index == 3 ? (
                <PLoader id="sentinela_avaliados">
                  <Oval
                    color={theme.colors.primary}
                    width={"max(2vw, 20px)"}
                    height={"max(2vw, 20px)"}
                    secondaryColor={theme.colors.primary}
                    visible={loading}
                  />
                  _
                </PLoader>
              ) : (
                ""
              )}{" "}
            </>
          ) : (
            ""
          )}
        </TableContainer>
      </Body>
      <Editar_Excluir_Operacoes
        open={!!editar_excluir_operacoes.ID}
        onClose={() => setEditarExcluirOperacoes({} as IOperacao)}
        operacao={editar_excluir_operacoes}
      />
      <ImovelModalOptions
        open={imovelModalOptionsOpen}
        onClose={() => setImovelModalOptions(false)}
      />
      <EditarRelacoesPref_Cart
        cartorio_relacao={cartorio_pref_relacao_focus}
        open={cartorio_relacao_modal}
        onClose={() => setCartorio_relacao_modal(false)}
      />
      <FiltroImovelModal
        open={openFiltroImovelModal}
        onClose={() => {
          setOpenFiltroImovelModal(false);
        }}
      />
      {/* <ModalLoader loading={loading} /> */}
    </Container>
  );
}
